import { render, staticRenderFns } from "./purchaseDetails.vue?vue&type=template&id=04668857&scoped=true"
import script from "./purchaseDetails.vue?vue&type=script&lang=js"
export * from "./purchaseDetails.vue?vue&type=script&lang=js"
import style0 from "./purchaseDetails.vue?vue&type=style&index=0&id=04668857&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04668857",
  null
  
)

export default component.exports